import { ReactNode } from 'react'

interface CustomFieldPreviewProps {
  title?: string
  additionalElements?: ReactNode
}

export const CustomFieldPreview = ({ title, additionalElements }: CustomFieldPreviewProps) => {
  return (
    <div className="input-container">
      <div className="group relative z-0 w-full">
        <div className="block rounded-t px-2.5 pb-[2px] pt-[27px] w-full text-[15px] text-gray-900 bg-white border border-gray-300 min-h-[55px]" />
        <label className="absolute text-[12px] text-gray-700 top-1.5 border-b z-10 origin-[0] left-2.5 flex gap-2 items-center max-w-[calc(100%-2rem)]">
          <span className="truncate" title={title}>
            {title}
          </span>
          {additionalElements}
        </label>
      </div>
    </div>
  )
}
